import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/** Quantity options delegate to the existing product quantity component and form. */
class BioClockVolumeSelector extends Component {
  #controller;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.closest('product-form-component')?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#quantityChanged, { signal: this.#controller.signal });
  }
  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }
  /** @param {Event} event Native radio keyboard and pointer change. */
  selectTier(event) {
    if (!(event.target instanceof HTMLInputElement) || !event.target.checked) return;
    const quantity = this.closest('product-form-component')?.querySelector('quantity-selector-component');
    if (!quantity?.setValue) return;
    quantity.setValue(event.target.value);
    quantity.updateButtonStates();
    quantity.onQuantityChange();
  }
  #quantityChanged = (event) => {
    const units = Number(event.detail.quantity);
    if (!Number.isInteger(units) || units < 1) return;
    for (const option of this.querySelectorAll('input[type="radio"]')) option.checked = Number(option.value) === units;
    const discount = units >= 12 ? 15 : units >= 6 ? 10 : units >= 3 ? 5 : 0;
    const subtotal = Number(this.dataset.basePrice) * units;
    const total = subtotal - Math.floor(Number(this.dataset.basePrice) * discount / 100) * units;
    const formatted = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(total / 100);
    const summary = this.querySelector('[ref="summary"]');
    if (summary) summary.textContent = summary.dataset.template.replace('[count]', String(units)).replace('[total]', formatted).replace('[discount]', String(discount));
  };
}
if (!customElements.get('bc-volume-selector')) customElements.define('bc-volume-selector', BioClockVolumeSelector);
